<template>
    <div id="secure">
        <!-- START NAV -->
        <TopMenu />
        <!-- END NAV -->
        <div class="container">
            <div class="columns">
                <div class="column is-12">
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a>Super Admin</a>
                            </li>
                            <!-- <li>
                <a href="../">Templates</a>
              </li>
              <li>
                <a href="../">Examples</a>
                            </li>-->
                            <li class="is-active">
                                <a href="#" aria-current="page">Home</a>
                            </li>
                        </ul>
                    </nav>
                    <section class="hero is-info welcome is-small">
                        <div class="hero-body">
                            <div class="container">
                                <h1 class="title">Hello, SuperAdmin {{ superEmail }}</h1>
                                <h2 class="subtitle">I hope you are having a great day!</h2>
                            </div>
                        </div>
                    </section>
                    <section class="info-tiles">
                        <div class="card">
                            <header class="card-header">
                                <loading
                                    :active.sync="isLoading1"
                                    :can-cancel="false"
                                    :is-full-page="false">
                                </loading>
                                <div class="tile is-ancestor has-text-centered">
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ schoolCount }}</p>
                                            <p class="subtitle">Schools</p>
                                        </article>
                                    </div>
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ classCount }}</p>
                                            <p class="subtitle">Classes</p>
                                        </article>
                                    </div>
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ teacherCount }}</p>
                                            <p class="subtitle">Teachers</p>
                                        </article>
                                    </div>
                                    <div class="tile is-parent">
                                        <article class="tile is-child box">
                                            <p class="title">{{ studentCount }}</p>
                                            <p class="subtitle">Students</p>
                                        </article>
                                    </div>
                                </div>
                            </header>
                        </div>
                        <a class="button is-small is-info" v-on:click="downloadData('school',1)">                            
                            <loading
                                :active.sync="isLoading5"
                                :can-cancel="false"
                                :is-full-page="false">
                            </loading>
                            Download School List
                        </a>
                        <a class="button is-small is-info" v-on:click="downloadData('user',1)">Download Teacher &amp; Student List</a>
                        <a class="button is-small is-info" v-on:click="downloadData('admin',1)">Download Active Admin &amp; Teacher Contact</a>
                        <a class="button is-small is-info is-outlined" v-on:click="downloadData('admin',0)">Download Inactive Admin &amp; Teacher Contact</a>
                    </section>
                    <div class="columns">
                        <div class="column is-12">
                            <div class="card events-card">
                                <header class="card-header">
                                    <p class="card-header-title">Request Plan Change</p>
                                </header>
                                <div class="card-table">
                                    <div class="content">
                                        <loading
                                            :active.sync="isLoading4"
                                            :can-cancel="false"
                                            :is-full-page="false">
                                        </loading>
                                        <table class="table is-fullwidth is-striped">
                                            <tbody>
                                                <tr v-for="requestPlanChange in listRequestPlanChange" :key="requestPlanChange._id">
                                                    <td width="5%">
                                                        <i class="fa fa-bell-o"></i>
                                                    </td>
                                                    <td v-on:click="viewPlanChangeRequest(requestPlanChange)" style="cursor: pointer;">{{ requestPlanChange.schoolID.name }}</td>
                                                    <!-- <td>{{ moment(school.addedOn).startOf('hour').fromNow() }} </td> -->
                                                    <td>{{ moment(requestPlanChange.addedOn).format('LLLL') }}</td>
                                                    <td v-on:click="viewPlanChangeRequest(requestPlanChange)" style="cursor: pointer;">Change to <b>{{ displayPlan(requestPlanChange.requestedPlan) }}</b></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <!-- <footer class="card-footer">
                                    <a class="card-footer-item" v-on:click="goSchools()">View All</a>
                                </footer> -->
                            </div>

                            <div class="card events-card">
                                <header class="card-header">
                                    <p class="card-header-title">Latest 20 Registered Schools</p>
                                </header>
                                <div class="card-table">
                                    <div class="content">                                        
                                    <loading
                                        :active.sync="isLoading2"
                                        :can-cancel="false"
                                        :is-full-page="false">
                                    </loading>
                                        <table class="table is-fullwidth is-striped">
                                            <tbody>
                                                <tr v-for="school in listLatestSchool" :key="school._id">
                                                    <!-- <td width="5%">
                                                        <i class="fa fa-bell-o"></i>
                                                    </td> -->
                                                    <td v-on:click="viewSchool(school._id,school.name)" style="cursor: pointer;">{{ school.name }}</td>
                                                    <!-- <td>{{ moment(school.addedOn).startOf('hour').fromNow() }} </td> -->
                                                    <td>{{ moment(school.addedOn).format('LLLL') }}</td>
                                                    <td>{{ displayPlan(school.plan) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <footer class="card-footer">
                                    <a class="card-footer-item" v-on:click="goSchools()">View All</a>
                                </footer>
                            </div>
                            
                            <div class="card events-card">
                                <header class="card-header">
                                    <p class="card-header-title">Schools with trial account</p>
                                </header>
                                <div class="card-table">
                                    <div class="content">                                        
                                    <loading
                                        :active.sync="isLoading3"
                                        :can-cancel="false"
                                        :is-full-page="false">
                                    </loading>
                                        <table class="table is-fullwidth is-striped">
                                            <tbody>
                                                <tr v-for="school in listTrialSchool" :key="school._id">
                                                    <td v-on:click="viewSchool(school._id,school.name)" style="cursor: pointer;">{{ school.name }}</td>
                                                    <!-- <td>{{ moment(school.addedOn).startOf('hour').fromNow() }} </td> -->
                                                    <td>{{ moment(school.addedOn).format('LLLL') }}</td>
                                                    <td class="level-right">
                                                        <a class="button is-small is-primary" v-on:click="viewSchool(school._id,school.name)">View Info</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <footer class="card-footer">
                                    <a class="card-footer-item" v-on:click="goSchools()">View All</a>
                                </footer>
                            </div>
                            
                            <div class="card events-card">
                                <header class="card-header">
                                    <p class="card-header-title">Inactive Schools</p>
                                </header>
                                <div class="card-table">
                                    <div class="content">                                        
                                    <loading
                                        :active.sync="isLoading6"
                                        :can-cancel="false"
                                        :is-full-page="false">
                                    </loading>
                                        <table class="table is-fullwidth is-striped">
                                            <tbody>
                                                <tr v-for="school in listInactiveSchool" :key="school._id">
                                                    <td v-on:click="viewSchool(school._id,school.name)" style="cursor: pointer;">{{ school.name }}</td>
                                                    <!-- <td>{{ moment(school.addedOn).startOf('hour').fromNow() }} </td> -->
                                                    <td>{{ moment(school.addedOn).format('LLLL') }}</td>
                                                    <td class="level-right">
                                                        <a class="button is-small is-primary" v-on:click="viewSchool(school._id,school.name)">View Info</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card events-card">
                                <header class="card-header">
                                    <p class="card-header-title">Testing Schools</p>
                                </header>
                                <div class="card-table">
                                    <div class="content">                                        
                                    <loading
                                        :active.sync="isLoading7"
                                        :can-cancel="false"
                                        :is-full-page="false">
                                    </loading>
                                        <table class="table is-fullwidth is-striped">
                                            <tbody>
                                                <tr v-for="school in listTestSchool" :key="school._id">
                                                    <td v-on:click="viewSchool(school._id,school.name)" style="cursor: pointer;">{{ school.name }}</td>
                                                    <!-- <td>{{ moment(school.addedOn).startOf('hour').fromNow() }} </td> -->
                                                    <td>{{ moment(school.addedOn).format('LLLL') }}</td>
                                                    <td class="level-right">
                                                        <a class="button is-small is-primary" v-on:click="viewSchool(school._id,school.name)">View Info</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <!-- <div class="column is-5">
                            <div class="card">
                                <header class="card-header">
                                    <p class="card-header-title">Inventory Search</p>
                                    <a href="#" class="card-header-icon" aria-label="more options">
                                        <span class="icon">
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </span>
                                    </a>
                                </header>
                                <div class="card-content">
                                    <div class="content">
                                        <div class="control has-icons-left has-icons-right">
                                            <input class="input is-large" type="text" placeholder />
                                            <span class="icon is-medium is-left">
                                                <i class="fa fa-search"></i>
                                            </span>
                                            <span class="icon is-medium is-right">
                                                <i class="fa fa-check"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopMenu from "./TopMenu";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Datepicker from "vuejs-datepicker";
const helper = require("../../../config/helper")
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    name: "SuperHome",
    components: {
        TopMenu,
        Loading
        // LatestPointsDaily,
        // LatestPointsOverall,
        // StaffAttendanceDaily,
        // StudentAttendanceDaily,
        // Loading,
        // Datepicker
    },
    data() {
        return {
            superId: "",
            superEmail: "",
            isLoading1: false,
            isLoading2: false,
            isLoading3: false,
            isLoading4: false,
            isLoading5: false,
            isLoading6: false,
            isLoading7: false,
            schoolCount: 0,
            classCount: 0,
            teacherCount: 0,
            studentCount: 0,
            listLatestSchool: [],
            listTrialSchool: [],  //list schools with 1 month unlimited trial that wil expire soon
            listInactiveSchool: [],
            listTestSchool: [],
            listRequestPlanChange: []
        };
    },
    created() {
        this.superId = localStorage.getItem("superId");
        this.superEmail = localStorage.getItem("superEmail");
        this.getStats();
        this.getLatestSchools();
        this.getSchoolsWithTrialAccount();
        this.getSchoolsThatRequestPlanChange();
        this.getInactiveSchools();
        this.getTestSchools();
        // console.log(this.$router.currentRoute.name)
        // this.currentRouteName = this.$router.currentRoute.name
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    mounted() {},
    methods: {
        getStats() {
            //this should be cached daily
            let self = this;
            self.isLoading1 = true;

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/stats", {
                    superEmail: localStorage.getItem("superEmail"),
                    page: "home"
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.schoolCount = response.data.schoolCount
                        self.classCount = response.data.classCount
                        self.teacherCount = response.data.teacherCount
                        self.studentCount = response.data.studentCount
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message:
                                "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading1 = false;
                });
        },
        getLatestSchools() {
            //this should be cached daily
            let self = this;
            self.isLoading2 = true;
            self.listLatestSchool = []

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/school/list", {
                    superEmail: localStorage.getItem("superEmail"),
                    what: "latest",
                    limit: 20
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.listLatestSchool = response.data.listSchool
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading2 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message: "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading2 = false;
                });
        },
        getSchoolsWithTrialAccount() {
            let self = this;
            self.isLoading3 = true;
            self.listTrialSchool = []

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/school/list", {
                    superEmail: localStorage.getItem("superEmail"),
                    what: "trial",
                    limit: 0
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.listTrialSchool = response.data.listSchool
                        console.log("self.listTrialSchool")
                        console.log(self.listTrialSchool)
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading3 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message: "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading3 = false;
                });
        },
        getSchoolsThatRequestPlanChange() {
            let self = this;
            self.isLoading4 = true;
            self.listRequestPlanChange = []

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/school/list", {
                    superEmail: localStorage.getItem("superEmail"),
                    what: "requestPlanChange",
                    limit: 0
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.listRequestPlanChange = response.data.listSchool
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading4 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message: "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading4 = false;
                });
        },
        getInactiveSchools() {
            let self = this;
            self.isLoading6 = true;
            self.listInactiveSchool = []

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/school/list", {
                    superEmail: localStorage.getItem("superEmail"),
                    what: "inactive",
                    limit: 0
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.listInactiveSchool = response.data.listSchool
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading6 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message: "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading6 = false;
                });
        },
        getTestSchools() {
            let self = this;
            self.isLoading7 = true;
            self.listTestSchool = []

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/school/list", {
                    superEmail: localStorage.getItem("superEmail"),
                    what: "test",
                    limit: 0
                })
                .then(response => {
                    if (response.data.success == true) {
                        self.listTestSchool = response.data.listSchool
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading7 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message: "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading7 = false;
                });
        },
        viewSchool(schoolID,schoolName){
            console.log("entering viewSchool with " + schoolID + ", " + schoolName)
            
            this.$store.commit('SUPER_UPDATE_VIEW_SCHOOL_ID',schoolID)
            this.$store.commit('SUPER_UPDATE_VIEW_SCHOOL_NAME',schoolName)
            localStorage.setItem('SUPER_VIEW_SCHOOL_ID',schoolID)
            localStorage.setItem('SUPER_VIEW_SCHOOL_NAME',schoolName)

            this.$router.push({
                name: "SuperSchoolEdit"
            });
        },
        viewPlanChangeRequest(requestPlanChange){
            console.log("entering viewPlanChangeRequest")

            console.log(requestPlanChange)
            
            this.$store.commit('SUPER_UPDATE_VIEW_PLAN_CHANGE_REQUEST_ID',requestPlanChange._id)
            this.$store.commit('SUPER_UPDATE_VIEW_PLAN_CHANGE_REQUEST_SCHOOL_NAME',requestPlanChange.schoolID.name)
            localStorage.setItem('SUPER_VIEW_PLAN_CHANGE_REQUEST_ID',requestPlanChange._id)
            localStorage.setItem('SUPER_VIEW_PLAN_CHANGE_REQUEST_SCHOOL_NAME',requestPlanChange.schoolID.name)

            this.$router.push({
                name: "SuperSchoolViewChangePlanRequest"
            });
        },
        displayPlan(plan){
            return helper.getPlanName(plan)
        },
        goSchools() {
            this.$router.push({
                name: "SuperSchools"
            });
        },
        downloadData(what,status){
            let self = this;

            if (what == "school"){
                var r = confirm("Are you sure you want to download the whole school list? This will generate and download all schools and it's details, and it will take some time. ");
                if (r != true){
                    console.log("475 tak jadi download school list")
                    return false;
                }
            }
            self.isLoading5 = true
            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + "/super/download", {
                    superEmail: localStorage.getItem("superEmail"),
                    what: what,
                    status: status,
                })
                .then(response => {
                    self.isLoading5 = false
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    if (what == "school"){
                        link.setAttribute('download', 'school_list.xlsx');
                    }else if (what == "user"){
                        link.setAttribute('download', 'teacher_and_student_list.xlsx');
                    }else if (what == "admin"){
                        link.setAttribute('download', 'admin_and_teacher_contact_list.xlsx');
                    }else{
                        link.setAttribute('download', 'data.xlsx');
                    }
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(e => {
                    console.log(e.response);
                    self.isLoading5 = false
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message: "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                });

        }
    }
};
</script>

<style scoped>
html,
body {
    font-size: 16px;
    line-height: 1.5;
    height: 100%;
    background: #ecf0f3;
}
nav.navbar {
    border-top: 4px solid #276cda;
    margin-bottom: 1rem;
}
.navbar-item.brand-text {
    font-weight: 300;
}
.navbar-item,
.navbar-link {
    font-size: 14px;
    font-weight: 700;
}
.columns {
    width: 100%;
    height: 100%;
    margin-left: 0;
}
.menu-label {
    color: #8f99a3;
    letter-spacing: 1.3;
    font-weight: 700;
}
.menu-list a {
    color: #0f1d38;
    font-size: 14px;
    font-weight: 700;
}
.menu-list a:hover {
    background-color: transparent;
    color: #276cda;
}
.menu-list a.is-active {
    background-color: transparent;
    color: #276cda;
    font-weight: 700;
}
.card {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
    margin-bottom: 2rem;
}
.card-header-title {
    color: #8f99a3;
    font-weight: 400;
}
.info-tiles {
    margin: 1rem 0;
}
.info-tiles .subtitle {
    font-weight: 300;
    color: #8f99a3;
}
.hero.welcome.is-info {
    background: #36d1dc;
    background: -webkit-linear-gradient(to right, #5b86e5, #36d1dc);
    background: linear-gradient(to right, #5b86e5, #36d1dc);
}
.hero.welcome .title,
.hero.welcome .subtitle {
    color: hsl(192, 17%, 99%);
}
.card .content {
    font-size: 14px;
}
.card-footer-item {
    font-size: 14px;
    font-weight: 700;
    color: #8f99a3;
}
.card-table .table {
    margin-bottom: 0;
}
.events-card .card-table {
    max-height: 250px;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Super/Home.vue